import { AnyAction } from 'redux';
import { stateNotificationsEnum } from '../../components/Utils/notification';
import { HIDE_NOTIFICATION, SET_NOTIFICATION } from '../types/types';

const initialState = {
	activated: false,
	message: '',
	type: stateNotificationsEnum.SUCCESS
};

export default function notificationReducer(
	state = initialState,
	action: AnyAction
) {
	switch (action.type) {
		case SET_NOTIFICATION:
			return {
				activated: true,
				message: action.payload.message,
				type: action.payload.type
			};
		case HIDE_NOTIFICATION:
			return { ...state, activated: false };
		default:
			return state;
	}
}
